export const isEmpty = (value) => {
  return (
    value == null || (typeof value === "string" && value.trim().length === 0)
  );
};

export function setTokenFromQuery() {
  try {
    const params = new URLSearchParams(window.location.search);
    const access = params.get("access");

    if (access) {
      const fullTokenInfo = atob(access);
      sessionStorage.setItem("oidc.default", fullTokenInfo);

      // remove only the "access" param and update URL
      params.delete("access");
      const { origin, pathname, hash } = window.location;
      const query = params.toString();
      const newUrl = origin + pathname + (query ? `?${query}` : "") + hash;
      window.history.replaceState({}, document.title, newUrl);
    }
  } catch (err) {
    console.error("Failed to parse access token from query:", err);
  }
}
